import { compose, withProps } from 'recompose'
import { createWithLazyEntities } from '@infotech/lib-api-middleware'

import {
  ESUZ_STATUSES_SCHEMA_NAME,
  esuzStatusesSelector,
  esuzStatusesApiActions,
  esuzStatusesEntitiesSelector,
} from 'api/esuzStatuses'

export const esuzStatusesDataPropName = `esuzStatuses`

const withEsuzStatuses = createWithLazyEntities({
  entitiesSelector: esuzStatusesEntitiesSelector,
  dataSelector    : esuzStatusesSelector,
  schemaName      : ESUZ_STATUSES_SCHEMA_NAME,
  fetchApiAction  : esuzStatusesApiActions.fetch,
  dataPropName    : esuzStatusesDataPropName,
})

export const esuzStatusesTransport = compose(
  withProps({
    query: {
      limit: -1,
    },
  }),
  withEsuzStatuses
)
